import { render, staticRenderFns } from "./ChangeOwnerModal.vue?vue&type=template&id=1f4947b0&"
import script from "./ChangeOwnerModal.vue?vue&type=script&lang=js&"
export * from "./ChangeOwnerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f4947b0')) {
      api.createRecord('1f4947b0', component.options)
    } else {
      api.reload('1f4947b0', component.options)
    }
    module.hot.accept("./ChangeOwnerModal.vue?vue&type=template&id=1f4947b0&", function () {
      api.rerender('1f4947b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/vistas/modals/ChangeOwnerModal.vue"
export default component.exports